import React, { useContext, useState, useEffect, createRef } from 'react';
import PropTypes from 'prop-types';
import { PDFExport } from '@progress/kendo-react-pdf';
import qrcode from 'qrcode-generator-es6';
import Context from '../../../context';
import Data from 'Content/content.json';
import { imageSet } from '../../../helper/Images';
import Doc from '../../../helper/DocService';
import Title from './Title';
import LeftSection from './LeftSection';
import RightSection from './RightSection';
import DownloadSection from './DownloadSection';
import { WEB_URL, language } from 'Root/constants';
import './LooksTutorial.scss';
let pdfExportComponent;

const LooksTutorial = ({
  recommendation,
  selectedLensType,
  download = false,
}) => {
  const { look, lensGuid, ignoreRecommendation, lensCleared } = useContext(
    Context
  );

  const {
    data: {
      looks,
      tutorials,
      productInfo: {
        [language]: { [selectedLensType]: lenses },
      },
    },
  } = Data;

  const lensSelected = lenses.findIndex((lens) => lens.guid === lensGuid);
  const lookData = looks[look === -1 ? 0 : look];
  const tutorialId = lookData['icon'];
  const [lookInfo, setLookInfo] = useState(lookData);
  const [tutorialImage, setTutorialImage] = useState(
    tutorials[tutorialId][language]['thumbnail']
  );
  const [tutorialSteps, setTutorialSteps] = useState(
    tutorials[tutorialId][language]['steps']
  );
  const [showPdfTitle, setShowPdfTitle] = useState(false);
  const [, setQrCode] = useState(imageSet[`${tutorialId}_${language}`]);
  const [, setAltQrCode] = useState(imageSet[`${tutorialId}_en`]);
  const [colorPallete, setColorPallete] = useState(
    tutorials[tutorialId][language]['color_pallete']
  );
  const [recommendedLens, setRecommendedLens] = useState(download ? 1 : -1);
  const bodyRef = createRef();
  const fileName = `Look_Tutorial_${lookInfo[language]['name']}`;

  const setInitValues = (lookArg) => {
    let initLookInfo = null;
    if (recommendation > -1) {
      const lookKey = lenses[recommendation]['recommended_look'];
      const recommendedLook = looks.findIndex(({ icon }) => icon === lookKey);
      initLookInfo = looks[recommendedLook];
    } else {
      initLookInfo = looks[lookArg];
    }
    initLookInfo = ignoreRecommendation === true ? looks[look] : initLookInfo;
    const tutId = initLookInfo['icon'];
    const lensKey = initLookInfo['lens'];
    setLookInfo(initLookInfo);
    setTutorialImage(tutorials[tutId][language]['thumbnail']);
    setTutorialSteps(tutorials[tutId][language]['steps']);
    setQrCode(imageSet[`${tutId}_${language}`]);
    setAltQrCode(imageSet[`${tutId}_en`]);
    setColorPallete(tutorials[tutId][language]['color_pallete']);
    setRecommendedLens(
      !lensCleared ? lenses.findIndex((lens) => lens.key === lensKey) : -1
    );
  };

  useEffect(() => {
    return () => {
      download && createPdf();
    };
  }, [download]);

  useEffect(() => {
    look > -1 && setInitValues(look);
    lensSelected > -1 &&
      look > -1 &&
      !lensCleared &&
      createQRCode(look, lensSelected);
  }, [look, lensSelected]);

  const createQRCode = (looksIndex, lensIndex) => {
    const qr = new qrcode(0, 'H');
    qr.addData(`${WEB_URL}#/looks/download/${looksIndex}/${lensIndex}`);
    qr.make();
    const my_element = document.getElementById('spanforqr');
    if (my_element) my_element.innerHTML = qr.createSvgTag({});
  };

  const createPdf = () => {
    setShowPdfTitle(true);
    Doc.createPdf(bodyRef.current);
    pdfExportComponent.save();
    setTimeout(() => {
      setShowPdfTitle(false);
    }, 700);
  };

  return (
    <React.Fragment>
      <span id="makePdf" className={showPdfTitle ? 'pdf-content' : null}>
        {/* for zh language code, we apply the above class */}
        <PDFExport
          ref={(component) => (pdfExportComponent = component)}
          fileName={fileName}
          paperSize="A2"
          margin="2cm"
        >
          <Title
            lenses={lenses}
            lookInfo={lookInfo}
            recommendedLens={recommendedLens}
            download={download}
            showPdfTitle={showPdfTitle}
          />

          <div
            className={`tutorials tutorials-looks tutorials--${lookInfo[
              language
            ]['name'].toLowerCase()}`}
          >
            <LeftSection
              lenses={lenses}
              colorPallete={colorPallete}
              tutorialImage={tutorialImage}
              lensCleared={lensCleared}
              lensSelected={lensSelected}
            />
            <RightSection tutorialSteps={tutorialSteps} />
          </div>
        </PDFExport>
      </span>

      {!download && !lensCleared && <DownloadSection createPdf={createPdf} />}
    </React.Fragment>
  );
};

LooksTutorial.propTypes = {
  selectedLensType: PropTypes.string,
  recommendation: PropTypes.number,
  download: PropTypes.bool,
};

export default LooksTutorial;
